import "../../css/pages/gallerySection.scss";
import React, { useState } from "react";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Button from "@mui/material/Button";
import { NavLink } from "react-router-dom";
import { iContent } from "./ContentShow";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Skeleton } from "@mui/material";
import ErrorFallback from "../../helpers/ErrorFallback";
import { withErrorBoundary } from "react-error-boundary";
import { useGetGalleries } from "../../queries";

function GallerySection() {
  const PAGE_SIZE = 3;
  const [page, setPage] = useState(0);

  const { data: galleryContents, isLoading: postsLoading } = useGetGalleries();

  const totalPages = Math.ceil((galleryContents?.length || 0) / PAGE_SIZE);

  const handleNext = () => {
    setPage((prev) => (prev < totalPages - 1 ? prev + 1 : prev));
  };

  const handlePrev = () => {
    setPage((prev) => (prev > 0 ? prev - 1 : prev));
  };

  const pagedContents = galleryContents?.slice(
    page * PAGE_SIZE,
    page * PAGE_SIZE + PAGE_SIZE
  );

  return (
    <div className="gallerySectionWrapper">
      <div className="gallerySectionHeader">
        <h3 className="gallerySectionHeaderTitle">گالری</h3>
        <div className="gallerySectionActions">
          <button
            className="gallerySectionButton"
            onClick={handlePrev}
            disabled={page === 0}
            name="gallerySectionButtonPrev"
            aria-label="Previous page"
          >
            <NavigateNextIcon fontSize="small" />
          </button>
          <button
            className="gallerySectionButton"
            onClick={handleNext}
            disabled={page >= totalPages - 1}
            name="gallerySectionButtonNext"
            aria-label="Next page"
          >
            <NavigateNextIcon
              fontSize="small"
              style={{
                transform: "rotate(180deg)",
              }}
            />
          </button>
        </div>
        <div className="galleryDivider"></div>
      </div>
      <div className="gallerySectionContent">
        {!postsLoading
          ? pagedContents?.map((value: iContent) => {
              return (
                <div key={value.id} className="contentPanelGallery">
                  <div className="contentButtonInfoGallery">
                    <div className="contentContainerMainGallery">
                      <div className="contentDateContainerMainGallery">
                        <div className="ContentAuthorNameGallery">
                          <div className="userIconGallery">
                            <AccountCircleIcon fontSize="small" />
                          </div>
                          <div>ادمین</div>
                        </div>
                        <div className="dateIconContentMainGallery">
                          <AccessTimeIcon fontSize="small" />
                        </div>
                        <div className="contentDateMainGallery">
                          {value.date}
                        </div>
                      </div>
                      <NavLink
                        className="navLinkGallery"
                        to={`/gallery/${value.id}`}
                      >
                        <div className="contentTitleMainGallery">
                          {value.title}
                        </div>
                      </NavLink>
                      <div
                        className="contentTextMainGallery"
                        dangerouslySetInnerHTML={{ __html: value.postText }}
                      />
                    </div>
                    <div className="buttonMainGallery">
                      <NavLink
                        className="navLinkGallery"
                        to={`/gallery/${value.id}`}
                        aria-label={`بیشتر بخوانید درباره ${value.title}`}
                      >
                        <Button
                          variant="contained"
                          className="contentActionButtonGallery"
                          name="contentActionButtonGallery"
                        >
                          {" "}
                          بیشتر بخوانید
                        </Button>
                      </NavLink>
                    </div>
                  </div>
                  <div className="contentImageContainerMainGallery">
                    <img
                      src={require(`../../${value.coverImage}`)}
                      alt="logo"
                    />
                  </div>
                </div>
              );
            })
          : Array(3)
              .fill(null)
              .map((_, index) => (
                <div key={index} className="contentPanelGallery">
                  <div className="contentButtonInfoGallery">
                    <div className="contentContainerMainGallery">
                      <div className="contentDateContainerMainGallery">
                        <div className="ContentAuthorNameGallery">
                          <div className="userIconGallery">
                            <AccountCircleIcon fontSize="small" />
                          </div>
                          <div>ادمین</div>
                        </div>
                        <div className="dateIconContentMainGallery">
                          <AccessTimeIcon fontSize="small" />
                        </div>
                        <div className="contentDateMainGallery">
                          <Skeleton variant="text" />
                        </div>
                      </div>
                      <NavLink
                        className="navLinkGallery"
                        to={`/gallery/${index}`}
                      >
                        <div className="contentTitleMainGallery">
                          <Skeleton variant="text" />
                        </div>
                      </NavLink>
                      <div className="contentTextMainGallery">
                        <Skeleton variant="text" />
                      </div>
                    </div>
                    <div className="buttonMainGallery">
                      <NavLink
                        className="navLinkGallery"
                        to={`/gallery/${index}`}
                        aria-label={`بیشتر بخوانید درباره بارگذاری...`}
                      >
                        <Skeleton
                          variant="rectangular"
                          className="contentActionButtonGallery"
                        />
                      </NavLink>
                    </div>
                  </div>
                  <div className="contentImageContainerMainGallery">
                    <Skeleton
                      variant="rectangular"
                      width="100%"
                      height="100%"
                    />
                  </div>
                </div>
              ))}
      </div>
    </div>
  );
}

export default withErrorBoundary(GallerySection, {
  FallbackComponent: ErrorFallback,
});
